import { useQuery } from '@tanstack/react-query'
import { api, query } from '../../api/client'
import type { StoreSearchResult } from '../../api/types'
import { formatCount } from '../../lib/format'
import { AppCell } from '../AppCell'

/** Live App Store results for a submitted term; opening one works because the server saved it. */
export function StoreResults({ term, storefront }: { term: string; storefront: string }) {
	const results = useQuery({
		queryKey: ['store-search', storefront, term],
		queryFn: () => api.get<StoreSearchResult[]>(`/api/v1/apps/store-search${query({ q: term, storefront })}`),
		enabled: term.length > 0,
		staleTime: 10 * 60_000,
	})
	if (!term) return <div className="empty">Press Return to search the {storefront.toUpperCase()} App Store.</div>
	if (results.isPending) return <div className="page-loading">Searching the App Store…</div>
	if (results.isError) return <div className="empty">App Store search failed: {results.error.message}</div>
	if (results.data.length === 0) return <div className="empty">The App Store has nothing for “{term}”.</div>
	return (
		<table>
			<tbody>
				{results.data.map((app) => (
					<tr key={app.id}>
						<td style={{ maxWidth: 0, width: '100%' }}>
							<AppCell app={app} />
						</td>
						<td className="muted small" style={{ whiteSpace: 'nowrap' }}>
							{app.genre ?? ''}
						</td>
						<td className="num small" style={{ whiteSpace: 'nowrap' }}>
							{app.rating === null || !app.ratingCount
								? '—'
								: `${app.rating.toFixed(1)} ★ (${formatCount(app.ratingCount)})`}
						</td>
						<td className="small" style={{ whiteSpace: 'nowrap' }}>
							{app.price ?? ''}
						</td>
					</tr>
				))}
			</tbody>
		</table>
	)
}
